module.exports = __webpack_public_path__ + "static/media/donate-hover.cdfc8ce8.png";